import { render, staticRenderFns } from "./AddUpdateComment.vue?vue&type=template&id=640517b8&scoped=true"
import script from "./AddUpdateComment.vue?vue&type=script&lang=ts"
export * from "./AddUpdateComment.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AddUpdateComment.vue?vue&type=style&index=0&id=640517b8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "640517b8",
  null
  ,true
)

export default component.exports